export default __webpack_public_path__ + "03338b6e1e6667cd322b8d898dca2687.png";